import React, { Component } from 'react'
import { connect } from 'react-redux'
import { logout } from './actions'
import { connectForm, Form, Field, Submit } from '~/form'
import { Grid, Segment, Header } from 'semantic-ui-react'
import Promise from 'bluebird'

class AuthLogoutContainer extends Component {
  componentDidMount() {
    let { logout } = this.props
    logout()
  }

  render() {
    return <div className="auth-logout">Logging out...</div>
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLogoutContainer)
